import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/pagination";

import ButtonComp from "components/PublicPagesReusable/ButtonComp";
import { SkeletonImage } from "components/PublicPagesReusable/MediaWithSkeleton";

const ReusableHomePageSlider = ({
  images = [],
  centerText,
  BottomBtns,
  btnLink,
  img,
}) => {
  return (
    <div className="our-champions-pte custom-container">
      {centerText && (
        <div className="text-center mb-5">
          {centerText()}
        </div>
      )}

      <div className="pte-slider-wrapper pte-slider">
        <Swiper
          modules={[FreeMode, Navigation, Pagination]}
          freeMode={true}
          loop={true}
          spaceBetween={20}
          slidesPerView={5.5}
          speed={500}
          navigation={false}
          breakpoints={{
            0: {
              slidesPerView: 1.8,
            },
            576: {
              slidesPerView: 1.8,
            },
            768: {
              slidesPerView: 3.8,
            },
            992: {
              slidesPerView: 4.8,
            },
            1200: {
              slidesPerView: 5.8,
            },
          }}
        >
          {images?.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="img-wrapper">
                <SkeletonImage
                  src={item.src}
                  alt={item.alt || `fame-img-${index}`}
                  className="img-fluid w-100 h-100"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Navigation + Pagination */}
        <div className="custom-swiper-controls d-none">
          <button className="custom-nav-btn custom-swiper-prev" style={{left:'33vw'}}>
            <svg width="14" height="14" viewBox="0 0 24 24">
              <path
                d="M15 18l-6-6 6-6"
                fill="none"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>

          <div className="custom-swiper-pagination"></div>

          <button className="custom-nav-btn custom-swiper-next" style={{right:'33vw'}}>
            <svg width="14" height="14" viewBox="0 0 24 24">
              <path
                d="M9 6l6 6-6 6"
                fill="none"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
          {BottomBtns &&
            <div className="text-center d-flex justify-content-center align-items-center mt-5" >
                <ButtonComp link={btnLink || "/wall-of-fame"} btnText={BottomBtns} img={img}/>
            </div>
          }
      </div>

      {/* {BottomBtns && (
        <div className="text-center mt-4">
          <ButtonComp
            link={"/auth/register"}
            btnText={BottomBtns}
            img={img}
          />
        </div>
      )} */}
    </div>
  );
};

export default ReusableHomePageSlider;